import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

const Controls = ({ children, className, disableClearControl, onClear, onDone, clearPrompt }) => (
  <div className={classNames('filter-controls', className)}>
    {children}
    <button
      className={classNames('bt bt--sm bt--tertiary filter-controls__button', {
        'filter-controls__button--disable': disableClearControl,
      })}
      onClick={onClear}
      disabled={disableClearControl}>
      {clearPrompt || <FormattedMessage id="filter.controls.clear" defaultMessage="Clear" />}
    </button>
    <button className="bt bt--sm bt--primary filter-controls__button" onClick={onDone}>
      <FormattedMessage id="filter.controls.done" defaultMessage="Done" />
    </button>
  </div>
);

Controls.propTypes = {
  children: PropTypes.element,
  className: PropTypes.string,
  disableClearControl: PropTypes.bool,
  onClear: PropTypes.func,
  onDone: PropTypes.func,
  clearPrompt: PropTypes.node,
};

export { Controls };
